// removed by extract-text-webpack-plugin
module.exports = {"full-height":"_2zSu3tIrJXZ5uZT4rHvzGe","book_review":"_3-SvLGIH9YhfygVw1Vs6XQ","row":"_2BfAU1cjPhBGrezL3PXi1s","title":"_1HgVUXnkeaY-X7nzFYBsnb","custom-card-booking-review-right":"sI2SOzxkomucJAEG9OUyZ","ant-card":"_26V6K83oryEnazad-YSWRp","footer":"i6oqeNS2Tn8Iq3vXAyHJD","btn-save":"_33dldxM-bwpZuveVa_yqp8","btn-directory":"_9GFO6ffK0OWp9xWaRPuP8","list_wrap":"_18vt_v-hO-GNhO-QcDeof-","popup_item":"_1yh1-tvUnNtm--8ng7krlC","btn_use_code":"_2x8iN7EOI0dRE73cSPuzah"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/booking_review.css
// module id = 245
// module chunks = 0